// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1DxA_","header":"Messages_header__nFxfw"};